var config = {
    getBotConfig:(botId)=> `/api/v2/config/bot/${botId}`,
    getChatSurveyConfig:(botId, relayState = '')=>  {
      let url = `/api/v1/technician/meta/${botId}`;
      if (relayState)
        url = url + "?relay_state=" + relayState;
      return url;
    },
    // getChatSurveyConfig: "http://www.json-generator.com/api/json/get/bVOaoywTfS?indent=2",
    submitChatSurveyConfig:(botId, relayState = '')=>  {
      let url = `/api/v1/technician/user-details/${botId}`;
      if (relayState)
        url = url + "?relay_state=" + relayState;
      return url;
    },
    getChatOnlyBot: `/api/v1/chat/solution`,
    getQueueList:(botId, relayState = '')=>  {
      let url = `/api/v1/technician/queue/list/${botId}`;
      if (relayState)
        url = url + "?relay_state=" + relayState;
      return url;  
    }
}

export default config;